import React from 'react';
import { CheckCircleRounded } from '@mui/icons-material';
import { Typography } from '@mui/material';
import theme from '@/shared/theme';

// Define the props interface
interface SubscriptionCardProps {
  title: string;
  items: string[];
  className?: string;
}

const SubscriptionCard: React.FC<SubscriptionCardProps> = ({ title, items, className }) => {
  return (
    <div className={`p-8 md:p-10 rounded-2xl bg-background w-full ${className}`}>
      <Typography variant="h3" component="h3" className="mb-6 md:mb-8">
        {title}
      </Typography>
      <div className="flex flex-col gap-4 md:px-6">
        {items.map((item, index) => (
          <div key={index} className="flex gap-4 items-center">
            <CheckCircleRounded style={{ color: theme.palette.complementary.light }} />
            <Typography variant="s1">{item}</Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionCard;
